/**
 * K线图KD密码装饰器
 */
import {mergeModelData} from '../../../util/index.js';
const model = {
  kList: {
    Type: Array,
    Default: () => ([])
  },
  dList: {
    Type: Array,
    Default: () => ([])
  }
};
const KLineKDDectorator = BaseClass => class extends BaseClass {
  constructor({data, ...rest}) {
    super({...rest, data: mergeModelData(model, data)});
  }
  _calcRange() {
    super._calcRange();
    const {kList, dList, start, end, kline} = this.state.data;
    const {height} = this.availArea;
    const baseSize = this.state.baseSize;
    const {
      sizeRatio,
      fontFamily,
    } = this.option.KD;
    const {
      kdHeight,
      triangleWidth,
      verticalSpace,
    } = this.measureKDLabel({
      text: 'K',
      fontSize: sizeRatio * baseSize * this.dpr,
      fontFamily
    });
    let _max = this.maxValue;
    let _min = this.minValue;
    let _tempMax = _max;
    let _tempMin = _min;
    const _c = (verticalSpace + kdHeight + triangleWidth * 2) / height;
    const _rate = (this.maxValue - this.minValue) * _c;
    dList.filter(a => a >= start && a < end).forEach(index => {
      const val = kline[index].low_px - _rate;
      if (val < _tempMin) {
        _tempMin = val;
        _min = kline[index].low_px;
      }
    });
    kList.filter(a => a >= start && a < end).forEach(index => {
      const val = kline[index].high_px + _rate;
      if (val > _tempMax) {
        _tempMax = val;
        _max = kline[index].high_px;
      }
    });
    if (_tempMax !== this.maxValue && _tempMin !== this.minValue) {
      this.maxValue = (_max - _min * _c - _max * _c) / (1 - 2 * _c);
      this.minValue = (_min - _max * _c - _min * _c) / (1 - 2 * _c);
    } else if (_tempMax !== this.maxValue) {
      this.maxValue = (_max - _min * _c) / (1 - _c);
    } else if (_tempMin !== this.minValue) {
      this.minValue = (_min - _max * _c) / (1 - _c);
    }
    this.baseValue = (this.maxValue + this.minValue) / 2;
  }
  _drawMain() {
    super._drawMain();
    const {
      left,
      bottom,
      width
    } = this.availArea;
    const {kline} = this.state.data;
    this._drawKD(kline, left, bottom, width);
  }
}
export default KLineKDDectorator;